import { FC } from "react";
import { ModalClose } from "assets/svg";

import ModalStatusIcon from "./components/ModalStatus/ModalStatusIcon";
import ModalStatusTitle from "./components/ModalStatus/ModalStatusTitle";
import { EButtonsAlign, EButtonsFlex, IContentAndButtonsWrapper, IModalProps } from "./types";
import {
  ButtonsContainer,
  Container,
  IconContainer,
  Image,
  MainActionButton,
  Message,
  SecondaryActionButton,
  StyledCloseButton,
  Title,
} from "./styles";

import "./styles.scss";

const DefaultContentAndButtonsWrapper: FC<IContentAndButtonsWrapper> = ({ children }) => {
  return <>{children}</>;
};

const ModalContent: FC<Partial<IModalProps>> = (props) => {
  const {
    imageURL,
    icon,
    type,
    title,
    statusTitle,
    message,
    secondaryMessage,
    mainButton,
    secondaryButton,
    onClose,
    canClose = true,
    showCloseButton = false,
    onCloseOnButtons = true,
    children = null,
    childrenBeforeButtons = true,
    contentAndButtonsWrapper,
    buttonsFlex = EButtonsFlex.COLUMN,
    buttonsMobileFlex = EButtonsFlex.COLUMN,
    buttonsAlign,
    buttonsMobileAlign,
  } = props;

  const _showCloseButton = showCloseButton && canClose;
  const ContentAndButtonsWrapper = contentAndButtonsWrapper || DefaultContentAndButtonsWrapper;
  const buttonsClassName = `flex-${buttonsFlex} mobile-flex-${buttonsMobileFlex} align-${buttonsAlign} mobile-align-${buttonsMobileAlign} ${type || ""}`;

  return (
    <Container className={`${!_showCloseButton ? "no-close-button" : ""}`}>
      {_showCloseButton && (
        <StyledCloseButton onClick={onClose} type="button" data-testId={"close-modal-btn"}>
          <ModalClose />
        </StyledCloseButton>
      )}

      {(!!icon || !!imageURL || !!type) && (
        <IconContainer>
          {icon}
          {imageURL && <Image src={imageURL} alt="" />}
          {type && <ModalStatusIcon type={type} />}
        </IconContainer>
      )}

      {statusTitle && <ModalStatusTitle type={type}>{statusTitle}</ModalStatusTitle>}
      {title && <Title>{title}</Title>}

      <ContentAndButtonsWrapper>
        {message && <Message>{message}</Message>}
        {secondaryMessage && <Message>{secondaryMessage}</Message>}

        {!!childrenBeforeButtons && children}

        {(mainButton || secondaryButton) && (
          <ButtonsContainer className={buttonsClassName}>
            {mainButton && (
              <MainActionButton
                onClick={() => {
                  mainButton.onClick?.();
                  if (onCloseOnButtons) {
                    onClose?.();
                  }
                }}
                type={mainButton?.type || "button"}
                disabled={!!mainButton?.disabled}
                className={`${mainButton.autoWidth ? "auto-width" : ""}`}
                data-testId={`main-action-btn ${mainButton.dataTestId || ""}`}
              >
                {mainButton.text}
              </MainActionButton>
            )}

            {!!secondaryButton && (
              <SecondaryActionButton
                onClick={() => {
                  secondaryButton.onClick?.();
                  if (onCloseOnButtons) {
                    onClose?.();
                  }
                }}
                type={secondaryButton?.type || "button"}
                disabled={!!secondaryButton?.disabled}
                className={`${secondaryButton.autoWidth ? "auto-width" : ""}`}
                data-testId={`secondary-action-btn ${secondaryButton.dataTestId || ""}`}
              >
                {secondaryButton.text}
              </SecondaryActionButton>
            )}
          </ButtonsContainer>
        )}

        {!childrenBeforeButtons && children}
      </ContentAndButtonsWrapper>
    </Container>
  );
};

export default ModalContent;
